import { z } from 'zod';
import { AVATARS, MAX_NAME_LENGTH, parseGameConfig } from './config';
import { GAME_MODES } from './modes';
import { isDailyDate } from './dates';

/** Zod primitives shared by the WebSocket protocol and the HTTP response contracts. */
export const textSchema = z.string().max(256);
/**
 * Parses to the normalized config. A stored config from before an optional field existed would
 * otherwise keep it undefined, and board selection would compute a NaN difficulty rank.
 */
export const configSchema = z.unknown().transform((value, context) => {
  const config = parseGameConfig(value);
  if (config) return config;
  context.addIssue({ code: 'custom', message: 'Invalid game configuration' });
  return z.NEVER;
});
export const modeSchema = z.enum(GAME_MODES);
export const dailyDateSchema = z.string().refine(isDailyDate);
export const boardSchema = z.array(z.string().regex(/^(?:[a-z]|qu)$/)).max(25);
/** A presented player name: trimmed, bounded, free of control characters. */
export const playerNameSchema = z
  .string()
  .trim()
  .min(1)
  .max(MAX_NAME_LENGTH)
  .regex(/^[^\u0000-\u001f\u007f]*$/);
export const avatarSchema = z.enum(AVATARS);
export const wordSchema = z.object({ w: z.string().max(64), pts: z.number(), dup: z.boolean().optional() });
